var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMuroWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 236.119,
    height: 186.311,
    viewBox: "0 0 236.119 186.311",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fbfaf1;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #fbfaf1;\n        stroke-linecap: round;\n        stroke-width: 3px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Muro_de_escalar_White",
    "data-name": "Muro de escalar  White",
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    className: "cls-1",
    d: "M39.991,37.993a5.847,5.847,0,0,1-4.943,2.884,16.235,16.235,0,0,0-3.443.449A15.222,15.222,0,0,0,20.318,53,15.349,15.349,0,0,0,49.337,62.51a2.055,2.055,0,0,1,2.149-1.2A15.374,15.374,0,1,0,39.991,37.993Zm13.05-2.363a10.954,10.954,0,0,1,1.5.1h0a10.437,10.437,0,0,1,8.815,9.009,10.315,10.315,0,0,1-2.545,8.169,10.483,10.483,0,0,1-8.822,3.435,7.09,7.09,0,0,0-7.212,4.136A10.368,10.368,0,1,1,32.772,46.17a11.107,11.107,0,0,1,2.376-.309,10.877,10.877,0,0,0,9.1-5.275A10.205,10.205,0,0,1,53.041,35.63Z",
    transform: "translate(4.675 60.173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    className: "cls-1",
    d: "M76.839,82.463l.309,0A15.336,15.336,0,0,0,91,73.641a2.062,2.062,0,0,1,2.176-1.157,15.265,15.265,0,0,0,1.556.11,15.375,15.375,0,0,0,2.8-30.544,15.348,15.348,0,0,0-15.378,6.883,5.849,5.849,0,0,1-5,2.784h-.005a16.018,16.018,0,0,0-3.448.379A15.2,15.2,0,0,0,62.182,63.533a15.394,15.394,0,0,0,14.658,18.93ZM67.045,64.644a10.35,10.35,0,0,1,7.735-7.678,11.045,11.045,0,0,1,2.376-.262h.01a10.88,10.88,0,0,0,9.2-5.09,10.261,10.261,0,0,1,10.393-4.642h0a10.442,10.442,0,0,1,8.633,9.186,10.321,10.321,0,0,1-2.715,8.119,10.193,10.193,0,0,1-7.837,3.328,9.766,9.766,0,0,1-1.052-.075,7.06,7.06,0,0,0-7.294,3.986,10.178,10.178,0,0,1-9.548,5.958,10.4,10.4,0,0,1-9.9-12.83Z",
    transform: "translate(99.337 87.965)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    className: "cls-1",
    d: "M79.141,48.66c.528,0,1.05-.027,1.561-.077a2.046,2.046,0,0,1,2.151,1.2A15.353,15.353,0,1,0,100.582,28.6a16.193,16.193,0,0,0-3.443-.449A5.846,5.846,0,0,1,92.2,25.262a15.348,15.348,0,1,0-13.057,23.4ZM68.833,32.015a10.432,10.432,0,0,1,8.815-9.009,10.226,10.226,0,0,1,10.3,4.854,10.876,10.876,0,0,0,9.1,5.275,11.046,11.046,0,0,1,2.373.309A10.387,10.387,0,1,1,87.41,47.755a7.056,7.056,0,0,0-6.474-4.168,7.383,7.383,0,0,0-.738.037,10.541,10.541,0,0,1-8.82-3.435A10.323,10.323,0,0,1,68.833,32.015Z",
    transform: "translate(53.726 38.116)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    className: "cls-1",
    d: "M59.545,44.774A15.39,15.39,0,0,0,74.916,29.4c0-10.388-10-10.388-15.371-10.388s-15.373,0-15.373,10.388A15.391,15.391,0,0,0,59.545,44.774Zm0-20.775c8.884,0,10.385,1.665,10.385,5.4a10.386,10.386,0,1,1-20.773,0C49.158,25.666,50.656,24,59.545,24Z",
    transform: "translate(74.205 -19.013)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    className: "cls-1",
    d: "M35.356,41.722A15.392,15.392,0,0,0,50.729,26.349c0-10.388-10-10.388-15.373-10.388s-15.371,0-15.371,10.388A15.39,15.39,0,0,0,35.356,41.722Zm0-20.775c8.887,0,10.388,1.665,10.388,5.4a10.386,10.386,0,1,1-20.773,0C24.971,22.614,26.471,20.947,35.356,20.947Z",
    transform: "translate(22.363 15.144)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    className: "cls-1",
    d: "M47.639,45.343a15.372,15.372,0,1,0,30.744,0c0-10.388-10-10.388-15.371-10.388S47.639,34.957,47.639,45.343Zm25.758,0a10.386,10.386,0,1,1-20.773,0c0-3.734,1.5-5.4,10.388-5.4S73.4,41.608,73.4,45.343Z",
    transform: "translate(23.156 122.596)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    className: "cls-2",
    d: "M2441.828,810.688V994",
    transform: "translate(-2441.828 -810.688)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    className: "cls-2",
    d: "M2441.828,810.688V994",
    transform: "translate(-2208.708 -810.688)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuroWhite);
export default __webpack_public_path__ + "static/media/MuroWhite.2d266cc4da91fb94f43577de2a32d2b9.svg";
export { ForwardRef as ReactComponent };